import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { TextQNAState } from './types';

const state: TextQNAState = {
  textQnA: null,
  jitterdelay: Math.floor(10 * Math.random()),
  channel_loading: {},
  scheduleTextQARefresh: false
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
